<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title class="fontLao">ຈັດການສີນຄ້າ</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>

        <v-spacer></v-spacer>
         <v-text-field
          v-model="search"
          append-icon="search"
          label="ຊອກຫາ"
          single-line
          hide-details
        ></v-text-field>
  <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2 fontLao">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6 sm6>
                    <img :src="imageUrl" height="150">
                  </v-flex>
                   <v-flex xs6 sm6 md6>
                     <v-btn raised class="primary" @click="onPickFile">Upload</v-btn>
                    <input 
                    type="file" 
                    style="display:none" 
                    ref="fileInput" 
                    accept="image/*" 
                    @change="onFilePicked">

                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.no" type="text" label="No"></v-text-field>
                  </v-flex>
                   <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.stockno" type="text" label="Stock no"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="ຊື່ສີນຄ້າ "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.bar" type="number" label="Barcode"></v-text-field>
                  </v-flex>
                       <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.price" type="number" label="ລາຄາຂາຍ"></v-text-field>
                  </v-flex>
          
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.avprice" type="number" label="ລາຄາຂາຍສະເລ່ຍ"></v-text-field>
                  </v-flex>
            <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.pro" label="ປະເພດສີນຄ້າ"></v-text-field>
                  </v-flex> -->
                  <div id="app">
                            <v-flex xs12 sm12 md12>
                        <v-select v-model="editedItem.cid"
                                 :items="categories"
                                    item-value="id"
                                 item-text="name"
                                  label="ປະເພດສີນຄ້າ"
                                ></v-select> 
                            </v-flex>
                          </div>

                  <!-- <v-flex xs12 sm6 md4> -->
                    <div id="app">
                            <v-flex xs12 sm12 md12>
                        <v-select v-model="editedItem.sid"
                                 :items="suppliers"
                                    item-value="id"
                                 item-text="name"
                                  label="ຜູ້ສະໜອງ"
                                ></v-select> 
                            </v-flex>
                          </div>
                            
                           <div id="app">
                            <v-flex xs12 sm12 md12>
                        <v-select v-model="editedItem.unid"
                                 :items="unit"
                                 item-value="id"
                                 item-text="name"
                                  label="ຫົວໜ່ວຍ"
                                ></v-select> 
                            </v-flex>
                          </div>

                    <!-- <v-text-field v-model="editedItem.sn" label="ຜູ້ສະໜອງ"></v-text-field>
                  </v-flex> -->
             
                </v-layout>
              </v-container>
            </v-card-text>
  
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>      <v-data-table
        :headers="headers"
        :items="mydata"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items=[10,20,50,100,500]
        class="elevation-1 fixtable">
        <!-- <template slot="items" slot-scope="props"> -->
          <!-- <td>{{ props.item.type }}</td>
          <td class="text-xs-center">{{ props.item.name}}</td>
          <td class="text-xs-center px-0"> -->
          <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.no }}</td>
          <td>
            <a v-if="props.item.url">
            <!-- <a v-if="props.item.url"  v-bind:href="props.item.url" target="_blank"> -->
            <v-icon  @click="url=props.item.url; dialog2=true;  "
              small
              class="mr-2"
             
            >
             picture_in_picture
            </v-icon>
            
            </a>
            {{ props.item.name }}</td>
   
          <td class="text-xs-center">{{ props.item.stockno }}</td>
          <td class="text-xs-center">{{ props.item.bar }}</td>
          <td class="text-xs-center">{{ props.item.cname }}</td>
          <td class="text-xs-center">{{ props.item.sname }}</td>
          <td class="text-xs-center">{{ props.item.uname }}</td>
          <td class="text-xs-center">{{ props.item.price }}</td>
          <td class="text-xs-center">{{ props.item.avprice }}</td>
          <!-- <td class="text-xs-center"><a v-bind:href="props.item.url">Pic</a></td> -->
          <td class="text-xs-center">
            <v-icon
              small
              @click="gotopagePromotion(props.item)"
            >
              broken_image
            </v-icon>
          </td>
          <td class="text-xs-center">
            <v-icon
              small
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <showImg :dialog2.sync="dialog2" :url.sync="url" />
    </div>
  </v-app>
</template>
<script>
import showImg from './PicModal.vue'
import firebase from 'firebase/app'
import 'firebase/storage'
import db from '@/firebase/init'
export default {
  components: {
      showImg
    },
    name:'Products',
     data: () => ({
    dialog2: false,
    dialog: false,
    url:null,
      search: '',
      pagination: {
        sortBy: 'no',descending: false,
      },
    headers: [
          { text: 'no ', value: 'no'  ,align: 'center',sortable: true,},
      {
        text: 'ຊື່ສີນຄ້າ',
        align: 'left',
        sortable: true,
        value: 'name'
      },
    //   { text: 'ຜູ້ສະໜອງ', value: 'name' ,align: 'center'},//ແກ້ໄຂອິກເດີ
    //  { text: 'Actions', value: 'name', sortable: false,align: 'center' }

    { text: 'Stock no ', value: 'stockno'  ,align: 'center'},
      { text: 'Barcode', value: 'bar'  ,align: 'center'},
      { text: 'ປະເພດສີນຄ້າ', value: 'cname' ,align: 'center'},
      { text: 'ຜູ້ສະໜອງ', value: 'sname'  ,align: 'center'},
      { text: 'ຫົວໜ່ວຍ', value: 'un'  ,align: 'center'},
      { text: 'ລາຄາຂາຍ', value: 'price' ,align: 'center'},
      { text: 'ລາຄາຂາຍສະເລ່ຍ', value: 'avprice' ,align: 'center'},
      // { text: 'ຮູບ', value: 'url' ,align: 'center'},
      { text: 'Pro', value: 'act', sortable: false,align: 'center' },
      { text: 'Actions', value: 'name', sortable: false,align: 'center' }
    ],
    mydata: [],
    suppliers:[],//ອາເຣ ເກັບຂໍ້ມູນຈາກໂຕອື່ນ
    categories:[],
    unit:[],
    imageUrl:'',

    image:null,
    editedIndex: -1,
       editedItem: {
      no:'',
      stockno:'',
      name: '',
      bar: '',
      sid:'',
      cid:'',
      unid:'',
      price:null,
      avprice:0,
      stt:1
    },
     defaultItem: {
       stockno:'',
       no:'',
      name: '',
      bar: '',
      sid:'',
      cid:'',
      unid:'',
      price:null,
      avprice:null,
      stt:1
    }
  }),

  computed: {
    formTitle () {
         return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
     this.initialize()
     this.initunit()
   this.initcategories()
   this.initsuppliers()
  },

  methods: {
    initialize () {
               var tsup =[];
             db.collection('suppliers').where("stt","==",1).get().then(snapshotc => {
                var c =[] 
             snapshotc.forEach(d=>{
               c[d.id]=d.data()
             })
             tsup = c
            }).catch(function(error) {
              console.log("Error getting document:", error);
            })

          var tcat =[];
             db.collection('categories').where("stt","==",1).get().then(snapshotc => {
                var c =[] 
             snapshotc.forEach(d=>{
               c[d.id]=d.data()
             })
             tcat = c
            }).catch(function(error) {
              console.log("Error getting document:", error);
            })


            var tunit =[];
             db.collection('unit').where("stt","==",1).get().then(snapshotc => {
                var c =[] 
             snapshotc.forEach(d=>{
               c[d.id]=d.data()
             })
             tunit = c
            }).catch(function(error) {
              console.log("Error getting document:", error);
            })
        let tdata=[];
       let ref = db.collection('products').where("stt","==",1).get()
        .then( snapshot => {
            snapshot.forEach(async doc => {
            let tmpdata =doc.data();
            tmpdata.id =doc.id;
            if (doc.data().sid) 
               tmpdata.sname = tsup[doc.data().sid].name;
            if (doc.data().cid) 
               tmpdata.cname = tcat[doc.data().cid].name;
            if (doc.data().unid) 
               tmpdata.uname = tunit[doc.data().unid].name;
            tdata.push(tmpdata)
            })
            this.mydata=tdata
            return tdata
        }).catch(err => {
          console.log('Error getting documents', err)
        });
        //ພາກສ່ວນທີ່ດຶງມາຂາກໂຕອື່ນ

 
        
    },
    initcategories(){
        let catdata=[];
         db.collection('categories').get()
        .then(snapshot => {
            snapshot.forEach(doc => {
            let tmpdata =doc.data();
            tmpdata.id =doc.id;
            catdata.push(tmpdata);
            });
            this.categories=catdata;
        })
        .catch(err => {
          console.log('Error getting documents', err);
        });
    },
    initunit(){
        let unitdata=[];
        db.collection('unit').where("stt","==",1).get()
        .then(snapshot => {
            snapshot.forEach(doc => {
            let tmpdata =doc.data();
            tmpdata.id =doc.id;
            unitdata.push(tmpdata);
            });
            this.unit=unitdata;
        })
        .catch(err => {
          console.log('Error getting documents', err);
        });
    },
    initsuppliers(){
       let sdata=[];
        db.collection('suppliers').where("stt","==",1).get()
        .then(snapshot => {
            snapshot.forEach(doc => {
            let tmpdata =doc.data();
            tmpdata.id =doc.id;
            sdata.push(tmpdata);
            });
            this.suppliers=sdata;
        })
        .catch(err => {
          console.log('Error getting documents', err);
        });
    },
    onPickFile(){
      this.$refs.fileInput.click();
    },
    onFilePicked(event){
      const files = event.target.files
      let filename = files[0].name
      if(filename.lastIndexOf('.')<=0){
        return alert('valid file');
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load',()=>{
        this.imageUrl=fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image=files[0]
    },
    editItem (item) {
       this.editedIndex = this.mydata.indexOf(item)
       this.editedItem = Object.assign({}, item)
       this.dialog = true
       console.log(item)
    },
    gotopagePromotion (item) {
        this.$router.push({ name: 'Promotion', params: { id:item.id  }})
    },
    deleteItem (item) {
      const index = this.mydata.indexOf(item)
        if ( confirm('Are you sure you want to delete this item ('+item.name+' )?')) {

           db.collection('products').doc(item.id).update({stt:0})
           this.mydata.splice(index, 1)
        }
    },

    close () {
          this.imageUrl=null
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      let imageUrl
      let key
      if (this.editedIndex > -1) {
       // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        this.editedItem.price =parseFloat(this.editedItem.price)
        this.editedItem.avprice =parseFloat(this.editedItem.avprice)
        let ref = db.collection('products').doc(id).update(this.editedItem)//,
          key = id
         if(this.image){
           const filename = this.image.name
          const ext = filename.slice(filename.lastIndexOf('.'))
          firebase.storage().ref('product/'+key+ext).put(this.image)
          .then(filedata=>{
           if(this.image){
          console.log(filedata.metadata.fullPath)
          var storage = firebase.storage();
         var starsRef = storage.ref(filedata.metadata.fullPath);
          // Get the download URL
          var _this = this
          starsRef.getDownloadURL().then(function(url) {
            console.log('url:',url)
            db.collection('products').doc(key).update({url:url}).then(()=>{
              _this.initialize()
            })
          })
            
         }
        }).then(()=>{
      this.imageUrl=null
          this.image=null
        })
         }
         else
         { this.initialize()}
          
      } else {
        this.editedItem.price =parseFloat(this.editedItem.price)
        let ref = db.collection('products').add(this.editedItem).then(data =>{
          key = data.id
          return key
        }).then(key=>{
          if(this.image){
          const filename = this.image.name
          const ext = filename.slice(filename.lastIndexOf('.'))
          return  firebase.storage().ref('product/'+key+ext).put(this.image)
          }else{
            this.initialize()
          }
        }).then(filedata=>{
           if(this.image){
          console.log(filedata.metadata.fullPath)
                  // Create a reference to the file we want to download
         var storage = firebase.storage();
         var starsRef = storage.ref(filedata.metadata.fullPath);
          // Get the download URL
          var _this = this
          starsRef.getDownloadURL().then(function(url) {
            console.log('url:',url)
            db.collection('products').doc(key).update({url:url}).then(()=>{
              _this.initialize()
            })
          })
         }
        })
      }
      this.close()
    }
  }
}
</script>

<style>
/* .v-datatable__actions {
    position: absolute;
    width: 100%;
    bottom: 60px;
} */

.fixtable>div>  td:first-child,
.fixtable>div>  table.v-table tbody td:not(:first-child),
.fixtable>div>  table.v-table tbody th:first-child,
.fixtable>div>  table.v-table tbody th:not(:first-child),
.fixtable>div>  table.v-table thead td:first-child, 
.fixtable>div>  table.v-table thead td:not(:first-child),
.fixtable>div>  table.v-table thead th:first-child,
.fixtable>div>  table.v-table thead th:not(:first-child) {
    padding: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/Products.vue